import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';
import withTranslations from '@wheelbox/lithejs-i18n';

import LoadingIndicator from '../../../../layout/loading-indicator';
import Message from '../../../../layout/message';
import SearchInput from '../search-input';
import SearchResults from '../search-results';

import { MessageType } from '../../../../layout/message/types';
import { SearchResult } from '../types';

import { createId } from '../../../../../utils';

type SearchModalContentProps = {
  searchString: string;
  isMatchCase: boolean;
  isSearching: boolean;
  searchResults: SearchResult[];
  onInput: (value: string) => void;
  onKeyPress: (event: KeyboardEvent) => void;
  onToggleMatchCase: () => void;
};

const SearchModalContent: LitheFC<SearchModalContentProps> = ({
  id = createId(),
  testId = 'search-modal-content',
  searchString,
  isMatchCase,
  isSearching,
  searchResults,
  onInput,
  onKeyPress,
  onToggleMatchCase,
}): LitheElement<'div'> => {
  const t = withTranslations('Search');

  if (isSearching) {
    return ['div', { id, 'data-testid': testId }, LoadingIndicator({})];
  }

  return [
    'div',
    { id, 'data-testid': testId, class: 'flex flex-col gap-4' },
    searchString && searchString.trim().length < 3
      ? Message({ type: MessageType.WARNING, content: t('alert') })
      : undefined,
    () =>
      SearchInput({
        id: `${id}-input`,
        value: searchString,
        isMatchCase,
        onInput,
        onKeyPress,
        onToggleMatchCase,
      }),
    searchString && searchString.trim().length > 2
      ? SearchResults({ string: searchString, results: searchResults })
      : undefined,
  ];
};

export default SearchModalContent;
